const baseURL = () => {
    return 'https://spaceways.storeganise.com/api';
}

export default baseURL;